export default "__VITE_ASSET__DbPUGYe6__"